/**
 * @generated SignedSource<<6c702372c3f222672c1e94d7c8ac8fcb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type nav_NotificationCenterButton_viewer$data = {
  readonly notificationCenter: {
    readonly id: string;
    readonly unreadNotificationCount: number;
  } | null;
  readonly " $fragmentType": "nav_NotificationCenterButton_viewer";
};
export type nav_NotificationCenterButton_viewer$key = {
  readonly " $data"?: nav_NotificationCenterButton_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"nav_NotificationCenterButton_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": require('./nav_NotificationCenterButton_viewer_refetchUnreadCount.graphql')
    }
  },
  "name": "nav_NotificationCenterButton_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NotificationCenter",
      "kind": "LinkedField",
      "name": "notificationCenter",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unreadNotificationCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "60606ad3e188e6605612abf43848bc94";

export default node;
